
const CreateButton = ({ onClick, label = 'Thêm' }) => {
    return (
        <div>
            <button type="button" onClick={onClick} className="btn m-1 btn-sm bg-primary">
                {label}
            </button>
        </div>
    );
};

export default CreateButton;
